import { Icon } from '@components/Elements/Icon'
import { Text } from '@components/Elements/Text'
import { useI18n } from '@lib/i18n'
import { useAuthStore } from '@stores/auth'
import { ChatMessage } from '@vetahealth/tuna-can-api'
import dayjs from 'dayjs'
import React from 'react'
import { View } from 'react-native'
import styled, { useTheme } from 'styled-components/native'

const Container = styled.View<{ isPatientMessage: boolean }>`
  flex-direction: ${({ isPatientMessage }) => (!isPatientMessage ? 'row' : 'row-reverse')};
  margin: 15px 20px;
  gap: 10px;
  align-items: flex-end;
`
const Avatar = styled.View<{ isPatientMessage: boolean }>`
  border-radius: 24px;
  height: 34px;
  width: 34px;
  background-color: ${({ isPatientMessage, theme }) => (isPatientMessage ? theme.colors.patientMessage : theme.colors.careManagerMessage)};
  justify-content: center;
  align-items: center;
`
const Wrapper = styled.View<{ isPatientMessage: boolean }>`
  flex: 1;
  background-color: ${({ isPatientMessage, theme }) => (isPatientMessage ? theme.colors.patientMessage : theme.colors.careManagerMessage)};
  border-radius: ${({ theme }) => theme.borderRadius.large}px;
  padding: 10px 15px;
`
const NameWrapper = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
`
const MessageWrapper = styled.View``

export function Message({ message }: { message: ChatMessage }): React.ReactNode {
  const t = useI18n()
  const theme = useTheme()
  const [user] = useAuthStore((state) => [state.user])
  const isPatientMessage = message.userId === message.senderId

  return (
    <Container isPatientMessage={isPatientMessage}>
      <Avatar isPatientMessage={isPatientMessage}>
        <View>
          <Icon size={13} color={theme.colors.primary} icon={['fad', isPatientMessage ? 'user' : 'user-doctor']} />
        </View>
      </Avatar>
      <Wrapper isPatientMessage={isPatientMessage}>
        <NameWrapper>
          <Text color={theme.colors.primary} size="dialog" ellipsizeMode="tail" weight="bold">
            {isPatientMessage ? `${user?.firstName}` : t('messaging.careManager')}
          </Text>
          <Text color={theme.colors.secondaryText} size="tiny">
            {dayjs(message.createdAt).format('LT')}
          </Text>
        </NameWrapper>
        <MessageWrapper>
          <Text weight="medium">{message.content.trim()}</Text>
        </MessageWrapper>
      </Wrapper>
    </Container>
  )
}
